module.exports = __webpack_public_path__ + "img/banner_home_left.fff60318.svg";